import React from 'react';
import {getRecaptchaV2SiteKey} from 'app/utils/recaptchaConfig';
import {isRecaptchaV2Available, loadRecaptchaV2Script} from 'app/utils/recaptchaV2Loader';

let recaptchaLoadAttemptsLeft = 6;

export default class Captcha extends React.PureComponent {
    state = {egbCaptcha: null, recaptchaId: null};

    componentDidMount() {
        loadRecaptchaV2Script()
            .then(() => {
                setTimeout(this.initializeRecaptcha, 100);
            })
            .catch(() => {});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reset !== this.props.reset && nextProps.reset) {
            if (this.state.recaptchaId !== null) {
                window.grecaptcha.reset(this.state.recaptchaId);
            }
        }
    }

    componentWillUnmount() {
        if (this.state.recaptchaId) {
            window.grecaptcha.reset(this.state.recaptchaId);
        }
    }

    initializeRecaptcha = () => {
        if (isRecaptchaV2Available()) {
            const recaptchaId = window.grecaptcha.render(this.recaptchaRef, {
                callback: this.props.onPass,
                sitekey: getRecaptchaV2SiteKey(),
                tabindex: 0,
                theme: 'dark'
            });
            this.setState({recaptchaId});
        } else if (--recaptchaLoadAttemptsLeft >= 0) {
            setTimeout(this.initializeRecaptcha, 250);
        }
    };

    setRecaptchaRef = dom => this.recaptchaRef = dom;

    render() {
        return <div ref={this.setRecaptchaRef}/>;
    }
}
